module.exports = __webpack_public_path__ + "images/category_lp/trading_card/assessment_achievements/4_6c7993f068b4e7c57f7bea397c71c9bb.png";